
import contractManagementGepoApi from "../contractManagementGepoApi";
import { serializeQueryArgs } from "../utils/infiniteScroll.utils";
import { CommentObjectClass, CreateComment, ListComment } from "./types";


const service = contractManagementGepoApi.injectEndpoints({
    endpoints: (builder) => ({
        createComment: builder.mutation<
            CreateComment,
            { object_class: CommentObjectClass, object_id: number, comment: string }
        >({
            query: ({ object_class, object_id, comment }) => {
                return {
                    url: `comments/${object_class}/${object_id}`,
                    method: "POST",
                    data: { comment },
                };
            },
            invalidatesTags: ["Comments"]

        }),
        getComments: builder.query<ListComment, { object_class: CommentObjectClass, object_id: number, page: number, per_page:number }>({
            query: ({ object_class, object_id, per_page, page }) => {
                return {
                    url: `comments/${object_class}/${object_id}`,
                    method: "GET",
                    params:{
                        page: page || 1,
						per_page: per_page || 20 ,
                    }
                };
            },
            serializeQueryArgs: serializeQueryArgs,
            providesTags: ["Comments"],

        }),
        deleteComment: builder.mutation<
            null,
            {
                id: number;
            }
        >({
            query: ({ id }) => {
                return {
                    url: `/comments/by-id/${id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: ["Comments"]
        }),
    }),

});

export const { useLazyGetCommentsQuery, useDeleteCommentMutation, useCreateCommentMutation } =
    service;

export default service;
